// @flow

import React, { Component } from 'react';

import './ColorScaleLegend.css';

class ColorScaleLegend extends Component {
  render() {
    const { blockHeight, blockWidth, colorScale, formater, values } = this.props;

    return (
      <div
        className="ColorScaleLegend"
        style={{
          width: `${blockWidth * values.length}px`,
        }}>
        {values.map((value, index) => {
          const colorAreaStyle = {
            backgroundColor: colorScale(value),
            height: `${blockHeight}px`,
            width: `${blockWidth}px`,
          };
          return (
            <div key={index} className="block">
              <div className="label">{formater(value)}</div>
              <div style={colorAreaStyle} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default ColorScaleLegend;



// WEBPACK FOOTER //
// ./src/components/ColorScaleLegend/ColorScaleLegend.js